import { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getHttpClient, getOutBoundedHttpClient } from './HttpClient';

type Request = <T>(
  url: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data?: any,
  config?: AxiosRequestConfig
) => Promise<T>;

let httpClient: AxiosInstance;
let outBoundedHttpClient: AxiosInstance;
export const initHttpClient = (apiBaseUrl: string) => {
  httpClient = getHttpClient(apiBaseUrl);
};

export const initOutBoundHttpClient = () => {
  outBoundedHttpClient = getOutBoundedHttpClient();
};
export class Core {
  get: Request = async (path, config) => await httpClient.get(path, config);

  put: Request = (path, data, config) => httpClient.put(path, data, config);

  post: Request = async (path, data, params) =>
    await httpClient.post(path, data, {
      ...params,
    });

  delete: Request = (path, data) => httpClient.delete(path, data);
  outBoundGet: Request = async (url, config) => await outBoundedHttpClient.get(url, config);
}

export const core = new Core();
